import {
  AttributeFulfillmentTypeDirectus,
  DirectusTranslation,
  EvaluationSubCriteriaDirectus,
  FulfillmentType,
} from '@frontend/directus';
import {ProvisioningType} from '@frontend/shared-api';
import {TabStatusEnum} from '../../tabs/tab-status.model';

export enum SubcriteriaRenderer {
  ATTRIBUTES = 'attributes',
  PROJECT_REFERENCES = 'project-references',
}

export interface SubcriteriaTab {
  id: number;
  scNumber: number;
  directusId: string;
  translations: DirectusTranslation[];
  attributes: SubcriteriaAttribute[];
  renderer: SubcriteriaRenderer;
  isSaving: boolean;
}

export interface ModuleTabForQuestionnaire {
  moduleId: number;
  moduleName: string;
  moduleTranslations: DirectusTranslation[];
  subcriteriaTabs: SubcriteriaTab[];
  status: TabStatusEnum;
  loaded: boolean;
}

export interface SubcriteriaAttribute {
  attributeId: number;
  directusId: string;
  scaNumber: number;
  importanceScore: string;
  translations: DirectusTranslation[];
  fulfillmentType?: FulfillmentType;
  score?: number;
  scoreAbsent: boolean;
  comment?: string;
  capabilityLevel?: number;
  provisioningType?: ProvisioningType;
  singleStage?: boolean;
  hasChanges: boolean;
}

export interface ECTab {
  id: number;
  ecNumber: number;
  title: string;
  directusId: string;
  translations: DirectusTranslation[];
  subcriteriaTabs: SubcriteriaTab[];
  moduleTabs?: ModuleTabForQuestionnaire[]; // EC3 only
  isSaving: boolean;
}

export interface DirectusDataMaps {
  attributeMap: Map<string, any>;
  subcriteriaMap: Map<string, EvaluationSubCriteriaDirectus>;
  fulfillmentTypeMap: Map<number, AttributeFulfillmentTypeDirectus>;
}

export interface TabBuilderOptions {
  isSaving?: boolean;
}

// values optional to allow updating separately.
export interface AttributeValueChange {
  directusId: string;
  score?: number;
  scoreAbsent?: boolean;
  comment?: string;
  capabilityLevel?: number;
  provisioningType?: ProvisioningType;
}

export interface ScoreMapEntry {
  score: number;
  scoreAbsent: boolean;
  comment?: string;
  capabilityLevel?: number;
  provisioningType?: ProvisioningType;
  singleStage?: boolean;
}

export interface TemplateData {
  ecTabs: ECTab[];
  projectReferenceCount: number;
}
